<template>
  <div class="evaluation-container">
    <div class="evaluation-header">
      <h2>集采评优结果</h2>
      <p class="subtitle">集中采购管理先进单位、优秀工作小组、先进个人评选结果公示</p>
    </div>

    <div v-loading="loading" class="evaluation-list">
      <div v-if="list.length === 0 && !loading" class="empty-state">
        <i class="el-icon-document" style="font-size:48px;color:#c0c4cc"></i>
        <p style="color:#909399;margin-top:10px">暂无评优结果</p>
      </div>

      <el-card v-for="item in list" :key="item.id" class="evaluation-card" shadow="hover">
        <div slot="header" class="card-header">
          <span class="card-title">{{ item.title }}</span>
          <el-tag type="success" size="small">已发布</el-tag>
        </div>
        <div class="card-content" v-html="item.resultContent || item.content"></div>
        <div class="card-footer">
          <span>发布时间: {{ item.updateTime || item.createTime }}</span>
          <span>发布人: {{ item.createName || '采购交易中心' }}</span>
        </div>
      </el-card>

      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.curPage"
          :page-sizes="[10, 20, 50]"
          :page-size="searchParams.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/config/utils/request";

export default {
  name: "evaluation",
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      searchParams: { curPage: 1, pageSize: 10 }
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      request({
        url: "/apis/pp/centralProc/queryEvaluationResults",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: this.searchParams
      }).then(res => {
        if (res.data.code === "0") {
          const data = res.data.data || {};
          this.list = data.list || data.rows || [];
          this.total = data.total || data.recordsTotal || 0;
        }
      }).catch(() => {}).finally(() => {
        this.loading = false;
      });
    },
    handleSizeChange(size) {
      this.searchParams.pageSize = size;
      this.fetchData();
    },
    handleCurrentChange(page) {
      this.searchParams.curPage = page;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.evaluation-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}
.evaluation-header {
  text-align: center;
  padding: 40px 0 30px;
}
.evaluation-header h2 {
  font-size: 24px;
  color: #303133;
  margin: 0;
}
.subtitle {
  color: #909399;
  font-size: 14px;
  margin-top: 8px;
}
.evaluation-card {
  margin-bottom: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}
.card-content {
  padding: 10px 0;
  line-height: 1.8;
  color: #606266;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  color: #909399;
  font-size: 12px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}
.empty-state {
  text-align: center;
  padding: 80px 0;
}
.pagination-wrapper {
  text-align: center;
  margin-top: 20px;
}
</style>
